// src/pages/Home.js
import React from 'react'

import Navbar from '../../Components/Navbar/navbar'
import Footer from '../../Components/Footer/footer'

import MedCarousel from '../../Components/Carousel/Products/medicinesCarousel'


import './Medici.css'

export default function medici() {


  return (
    <>
<Navbar/>
      <section className='health_section content' >

          <MedCarousel />
      </section>

<Footer/>
    </>
  )
}























